import { createFileRoute } from '@tanstack/react-router';

import QuoteRequestsPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestsPage/QuoteRequestsPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/')({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { negotiationId } = Route.useParams();
    return <QuoteRequestsPage context={{ type: 'NegotiationV2', id: negotiationId }} />;
}
